export const internalLinkStyle = ({ palette = {}, elementLocator = 'a', isGreyBackground = false }) => ({
  [`& ${elementLocator}`]: {
    textDecoration: 'none',
    color: isGreyBackground ? palette.themeDarkAlt : palette.themePrimary,
    '&:focus': {
      textDecoration: 'none',
      outline: `1px solid ${palette.neutralSecondary}`,
    },
    '&:hover': {
      textDecoration: 'underline',
      color: palette.themeDarker,
    },
  },
});
